import React, { useEffect, useState } from 'react';
import studentService from '../../services/studentService';

/**
 * AuthImage — fetches an image/doc URL with JWT auth header and renders it.
 * Use this instead of <img src="..."> for protected backend images.
 */
const AuthImage = ({ url, alt = '', style = {}, fallback = null }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [failed,  setFailed]  = useState(false);

  useEffect(() => {
    if (!url) { setFailed(true); return; }
    let objectUrl = null;
    studentService.fetchImageAsBlob(url).then(u => {
      if (u) { objectUrl = u; setBlobUrl(u); }
      else setFailed(true);
    });
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url]);

  if (failed)  return fallback || null;
  if (!blobUrl) return <div style={{ ...style, background:'#F0EDE8', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, color:'#9B9B9B' }}>Loading…</div>;
  return <img src={blobUrl} alt={alt} style={style} />;
};

export default AuthImage;